<template>
  <div class="getVer">
    <div class="goback"><img
      @cilck="backFn"
      src="../../../static/img/gzs/icon/icon_back -B.png"
      alt=""
    /></div>
    <div class="code">
      <div class="codeOne">请输入验证码</div>
      <div class="codeTip">验证码已发送至 +{{ phone }}</div>
      <div class="codeInp">
        <input v-model="code" type="text" placeholder="请输入验证码" @input="phoneInp" maxlength="6">
      </div>
      <div class="recode">
        <button :style="{background:background}" :disabled="disable" @click="getVerCode">{{ text }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../util/gaeaApiConfig";

export default {
  data() {
    return {

      text: "获取验证码",
      background: "#DEB7B0",
      disable: true,
      focus: true, //input焦点，用于键盘隐藏后重新唤起
      // 验证码框颜色
      codeclolor: "#313131", //自定义光标的颜色
      // 验证码获取秒数
      retrievecount: 60, //这是重新获取验证码的倒计时
      code: "", //这是用户输入的验证码
      disabled: true,
      phone: "",
    };
  },

  mounted() {
    console.log(this.$route.query);
    this.phone = this.$route.query.phone
    this.getVerCode()
  },
  methods: {
    backFn() {
      this.$router.push({
        path:'/order_login'
      })
    },
    phoneInp(){
      if(this.code.length == 6){
          let data = {
            phone: this.phone,
            udid: "2",
            area_code: "86",
            terminal: "h5",
            platform_type: "1",
            login_type: "2",
            verification_code: this.code,
          };
        http.post("users/login",data).then(res=>{
          console.log(res.data.data);
          localStorage.setItem("user_id", res.data.data.user_id);
          localStorage.setItem(
            "refresh_token",
            res.data.data.refresh_token
          );
          localStorage.setItem(
            "token",
            res.data.data.access_token
          );
          this.$router.push({
            path: "/prescriptionlist",
            query: {
              diagnosis_prescription_id: this.$route.query
                .diagnosis_prescription_id,
            },
          });
          setTimeout(()=>{
            if (location.href.indexOf("#") == -1) {
              //在当前页面地址加入"#"，使下次不再进入此判断
              location.href = location.href + "#";
              location.reload();
            }
          },1000)
        })
      }
    },
    // 获取验证码
    getVerCode() {
      let phoneInpText = this.phone
      let reg = /^1[3|4|5|7|8][0-9]{9}$/;
      const TIME_COUNT = 60;
      if (reg.test(phoneInpText)) {
        console.log('手机号验证通过')
        this.retrievecount = TIME_COUNT;
        this.background = "#DEB7B0"
        let data = {}
        data.phone = phoneInpText
        data.area_code = '86'
        data.type = 'login'
        data.platform = "h5"
        data.platform_type = "1"
        http.post('sms_code',data).then(res => {
        }).catch(err => {
          console.log(err)
        })
        this.timer = setInterval(() => {
          ;
          if (this.retrievecount > 0 && this.retrievecount <= TIME_COUNT) {
            this.retrievecount--;
            this.disable = true
            this.text = this.retrievecount-- +"秒后重新获取"
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.disable=false
            this.text = "重新获取"
          }
        }, 1000)
      } else {
        alert('手机号错误请重新输入')
        this.retriePhonenum = ''
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.getVer {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;

  .goback {
    width: 100%;
    height: 30px;
    padding-left: .5rem;
    box-sizing: border-box;
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .code {
    width: 100%;
    height: auto;
    padding-left: 30px;
    padding-right: 30px;
    box-sizing: border-box;

    .codeOne {
      width: 100%;
      height: 30px;
      font-size: 1.5rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      margin-top: 40px;
    }

    .codeTip {
      margin-top: 10px;
      width: 100%;
      height: 30px;
      font-size: 0.88rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }

    .codeInp {
      width: 100%;
      height: 3rem;

      input {
        width: 100%;
        height: 3rem;
        background: #fff;
        border: none;
        border-bottom: 1px solid #ccc;
      }
    }
  }


  .recode {
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;

    button {
      float: right;
      font-size: 0.825rem;
      width: 123px;
      height: 40px;
      border-radius: 8px;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/getVer.vue